import React from 'react'
import PropTypes from 'prop-types'
import { CheckBox } from 'components'

import Select, { components } from 'react-select'
import AsyncSelect from 'react-select/async'

import { ArrowDown2 } from 'iconsax-react'

import styles from './styles.module.css'
import useColors from 'utils/Colors'

const AsyncSelectMenu = (props) => {
  const Colors = useColors()

  return (
    <components.MenuList {...props}>
      {props.children}
      <div className={styles.more_btn}>
        مشاهده بیشتر
        <ArrowDown2
          size={16}
          style={{ marginRight: 2 }}
          color={Colors.Primary[2]}
        />
      </div>
    </components.MenuList>
  )
}

const MultiSelectOption = ({ isSelected, ...props }) => {
  return (
    <components.Option {...props}>
      <div className="d-flex align-items-center">
        <div style={{ marginLeft: 6 }}>
          <CheckBox checked={isSelected} />
        </div>
        {props.children}
      </div>
    </components.Option>
  )
}

const DropDown = ({ isAsync, ...props }) => {
  const getComponents = () => {
    let comps = {}
    if (isAsync) {
      comps.MenuList = AsyncSelectMenu
    }
    if (props.isMulti) {
      comps.Option = MultiSelectOption
    }

    return comps
  }

  return (
    <Select
      className={styles.drop_down}
      classNamePrefix="dropdown"
      components={getComponents()}
      {...props}
    />
  )
}

DropDown.propTypes = {
  options: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  menuPlacement: PropTypes.string,
  isSearchable: PropTypes.bool
}

DropDown.defaultProps = {
  placeholder: 'لطفا انتخاب کنید',
}

export default DropDown
